<template>
  <v-dialog
    :value="!userHasGivenConsent"
    max-width="555px"
    :persistent="true"
    class="SlcTosDialog"
  >
    <v-card class="SlcTosDialog">
      <v-divider class="SlcTosDialog-topBorder"></v-divider>
      <v-card-title>
        <v-layout column justify-center>
          <v-layout justify-center>
            <img class="SlcTosDialog-logo" src="/img/svg/favicon.svg" alt="" />
          </v-layout>
          <v-layout justify-center class="u-fw500 pt-1">dpa-Select</v-layout>
        </v-layout>
      </v-card-title>
      <v-card-text class="body-1">
        <p>
          Willkommen bei dpa-Select! Bitte nehmen Sie sich noch ein paar
          Augenblicke Zeit, bevor es losgeht. Die Datenschutz-Bestimmungen
          finden Sie
          <a href="javascript:;" @click.stop="toggleDataPrivacyStatementModal"
            >hier</a
          >
        </p>
        <v-form :value="userHasGivenConsent" lazy-validation ref="form">
          <v-checkbox
            v-model="agreeTos"
            persistent-hint
            ref="termsAndConditions"
            :rules="termsAndConditionsRules"
            required
          >
            <div slot="label">
              Ich stimme den
              <a href="javascript:;" @click.stop="toggleTermsAndConditionsModal"
                >AGB</a
              >
              zu.
            </div>
          </v-checkbox>
        </v-form>
        <v-layout justify-center>
          <v-btn
            depressed
            @click.prevent="submit"
            class="SlcTosDialog-button primary"
          >
            Weiter
          </v-btn>
        </v-layout>
        <v-layout justify-center>
          <v-btn
            flat
            depressed
            class="SlcTosDialog-button u-borderBlue u-colorBlue"
            @click="logout"
            >Abbrechen</v-btn
          >
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog
      :value="dataPrivacyStatementModal"
      :persistent="true"
      width="555px"
    >
      <slc-data-privacy-statement
        @dataPrivacyStatementModal="toggleDataPrivacyStatementModal"
        :showActions="true"
      ></slc-data-privacy-statement>
    </v-dialog>
    <v-dialog :value="termsAndConditionsModal" :persistent="true" width="555px">
      <slc-terms-and-conditions
        @termsAndConditionsModal="toggleTermsAndConditionsModal"
        :showActions="true"
      ></slc-terms-and-conditions>
    </v-dialog>
  </v-dialog>
</template>

<script>
/* eslint-disable camelcase */
import { mapActions } from "vuex";
import useAuthentication from "@/composition/useAuthentication";
import SlcDataPrivacyStatement from "./SlcDataPrivacyStatement.vue";
import SlcTermsAndConditions from "./SlcTermsAndConditions.vue";

const rules = {
  required: v => !!v || "Pflichtfeld"
};

export default {
  setup() {
    const { logout, profile } = useAuthentication();
    return {
      logout,
      profile
    };
  },
  components: {
    SlcDataPrivacyStatement,
    SlcTermsAndConditions
  },
  props: {
    eventBus: {
      type: Object
    }
  },
  methods: {
    ...mapActions("auth", ["checkTOS"]),
    /**
     * @returns {void}
     */
    toggleDataPrivacyStatementModal() {
      this.dataPrivacyStatementModal = !this.dataPrivacyStatementModal;
    },
    /**
     * @returns {void}
     */
    toggleTermsAndConditionsModal() {
      this.termsAndConditionsModal = !this.termsAndConditionsModal;
    },
    /**
     * Validates the form sends it.
     * @returns {void}
     */
    async submit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      try {
        await this.checkTOS();
        this.userHasGivenConsent = true;
        localStorage.userHasGivenConsent = this.userHasGivenConsent;
      } catch (error) {
        if (this.eventBus) {
          this.eventBus.$emit("appMessage", {
            model: true,
            text: error.message
          });
        } else {
          console.warn(error); // eslint-disable-line
        }
      }
    }
  },
  data() {
    return {
      agreeTos: false,
      dataPrivacyStatementHref: "",
      dataPrivacyStatementModal: false,
      termsAndConditionsModal: false,
      termsAndConditionsRules: [rules.required],
      userHasGivenConsent: true
    };
  },
  mounted() {
    // wait until the profile loaded
    setTimeout(() => {
      // use localStorage: https://v2.vuejs.org/v2/cookbook/client-side-storage.html
      if (!localStorage.getItem("userHasGivenConsent") === null) {
        this.userHasGivenConsent = localStorage.userHasGivenConsent;
      } else {
        this.userHasGivenConsent = this.profile.firstName
          ? !!this.profile.termsAndConditions &&
            !!this.profile.dataPrivacyStatement
          : true;
        localStorage.userHasGivenConsent = this.userHasGivenConsent;
      }
    }, 1500);
  }
};
</script>

<style>
/** @define SlcTosDialog; weak */
@import "factorial-utils-font-weight";
@import "../../utils/utils-headlines.css";
@import "../../utils/utils-color/index.css";

@font-face {
  font-family: "FuturaBT-Medium";
  src: url("../../assets/fonts/36D6D3_0_0.eot");
  src: url("../../assets/fonts/36D6D3_0_0.eot?#iefix")
      format("embedded-opentype"),
    url("../../assets/fonts/36D6D3_0_0.woff2") format("woff2"),
    url("../../assets/fonts/36D6D3_0_0.woff") format("woff"),
    url("../../assets/fonts/36D6D3_0_0.ttf") format("truetype");
}

.SlcTosDialog {
  font-family: "FuturaBT-Medium", sans-serif;
}

.SlcTosDialog-logo {
  height: 58px;
  width: 58px;
}

.SlcTosDialog label {
  max-width: max-content !important;
}

.SlcTosDialog-topBorder {
  background-color: var(--color-blue) !important;
  height: 16px;
}

.SlcTosDialog-button {
  border-radius: 18px;
  border-style: solid;
  border-width: 1px !important;
}

.SlcTosDialog-button:disabled {
  border-color: transparent !important;
}
</style>
